import API from "../../api";
import {
  API_SEARCH_MACHINES,
  API_SEARCH_BY_MACHINE_NAME
} from "../../constants/api";

const searchMachines = async (data) => {
  try {
    const response = await API.get(API_SEARCH_MACHINES, {
      params: data,
    });
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const searchByMachine = async (data) => {
  try {
    const response = await API.get(API_SEARCH_BY_MACHINE_NAME, {
      params: data,
    });
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const MachineInput = {
  searchMachines,
  searchByMachine
};

export {
  MachineInput as default,
  searchMachines,
  searchByMachine
}